module.exports = __webpack_public_path__ + "img/xls.6b0f7d19.jpg";